import React from 'react';
import Loadable from 'react-loadable';

import FirstLoader from '../FirstLoader/FirstLoader';

const LoadableWithdrawWizard = Loadable({
  loader: () => import(/* webpackChunkName: "Withdraw" */ './WithdrawWizard'),
  modules: ['./Withdraw'],
  loading: () => <FirstLoader />
});

export default LoadableWithdrawWizard;
